import axios from './financeiroApi';

const getParams = (params) => {
  let newParams;
  if (params?.filtroAvancado) {
    newParams = {
      ...params,
      ...params.filtroAvancado,
      compraId: params.filtroAvancado.compraId ? parseInt(params.filtroAvancado.compraId) : undefined,
    };
    delete newParams.filtroAvancado;
  } else {
    newParams = params;
  }

  newParams = {
    ...newParams,
    dataCompra: newParams?.dataCompra?.format('YYYY-MM-DD'),
  };

  return newParams;
};

const compraApi = (tipo = 'PRODUTO') => {
  const getPath = () => {
    return `/api/v1/backend/compra`;
  };
  const getProdutoServicoPath = () => {
    return `${getPath()}/${tipo === 'PRODUTO' ? 'produto' : 'servico'}`;
  };

  return {
    buscarTodos: (search) => {
      const url = `${getPath()}`;
      return axios.get(url, { params: getParams(search) });
    },
    buscar: (compraId) => {
      const url = `${getPath()}/${compraId}`;
      return axios.get(url);
      // return servicoMock.getOne(compraId);
    },
    criar: (servico, permitirDuplicada) => {
      const url = `${getProdutoServicoPath()}?permitirDuplicada=${!!permitirDuplicada}`;
      return axios.post(url, servico);
    },
    atualizar: (servico, permitirDuplicada) => {
      const url = `${getProdutoServicoPath()}/${servico.id}?permitirDuplicada=${!!permitirDuplicada}`;
      return axios.put(url, servico);
    },
    excluir: (params) => {
      const url = `${getPath()}`;
      return axios.delete(url, {
        data: getParams(params),
      });
    },
    enviarAnexo: (formData) => {
      return axios.put(`${getPath()}/anexo/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          type: 'formData',
        },
      });
    },
    download: (url) => {
      return axios.get(url);
    },
    getAnexoUrl: (anexoId) => {
      return `${process.env.REACT_APP_BASE_URL}/api/v1/backend/compra/anexo/download/${anexoId}`;
    },
  };
};

export { compraApi };
